
import React from 'react';

import { DATA_OPERATIONS } from '../../reducers/data';

import Operation from './Operation.state';
import OperationListView from './OperationList.view';

const OperationList = ({
    onCollapseClick,
    onExpandClick,
    pricelistData,
    readOnly,
    state
}) => {

    const handleRenderOperation = (operation, n) => {
        return (
            <Operation
                col={n}
                expanded={(state[operation.id] === true)}
                key={operation.id}
                onCollapseClick={onCollapseClick}
                onExpandClick={onExpandClick}
                operation={operation}
                pricelistData={pricelistData}
                readOnly={readOnly}
            />
        );
    }

    return (
        <OperationListView
            items={DATA_OPERATIONS}
            onRenderOperation={handleRenderOperation}
        />
    );
}

export default OperationList;
